import { Box, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {
  HeaderFilterBox,
  CustomTextField,
} from '../../../common/components';

const MovementConceptsFilters = ({
  searchTerm,
  onSearchChange,
}) => {
  const inputStyles = {
    width: { xs: '100%', sm: '48%', md: '30%' },
    mt: 0,
  };

  return (
    <HeaderFilterBox variant="oneRow">
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          alignItems: 'center',
          width: '100%',
        }}
      >
        <CustomTextField
          label="Buscar"
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          size="medium"
          placeholder="Nombre o código"
          sx={{ ...inputStyles, width: { xs: '100%', sm: '48%', md: '40%' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'primary.main' }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </HeaderFilterBox>
  );
};

export default MovementConceptsFilters;
